import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ContractClass } from './contract-class.model';
import * as ContractClassActions from './contract-class.actions';

export const contractClassesFeatureKey = 'contractClasses';

export interface State extends EntityState<ContractClass> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ContractClass> = createEntityAdapter<ContractClass>({selectId: (model: ContractClass) => model.ClassListID});

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});


export const classReducer = createReducer(
  initialState,
  on(ContractClassActions.addContractClass,
    (state, action) => adapter.addOne(action.contractClass, state)
  ),
  on(ContractClassActions.upsertContractClass,
    (state, action) => adapter.upsertOne(action.contractClass, state)
  ),
  on(ContractClassActions.addContractClasses,
    (state, action) => adapter.addMany(action.contractClasses, state)
  ),
  on(ContractClassActions.upsertContractClasses,
    (state, action) => adapter.upsertMany(action.contractClasses, state)
  ),
  on(ContractClassActions.updateContractClass,
    (state, action) => adapter.updateOne(action.contractClass, state)
  ),
  on(ContractClassActions.updateContractClasses,
    (state, action) => adapter.updateMany(action.contractClasses, state)
  ),
  on(ContractClassActions.deleteContractClass,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ContractClassActions.deleteContractClasses,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ContractClassActions.loadContractClasses,
    (state, action) => adapter.setAll(action.contractClasses, state)
  ),
  on(ContractClassActions.clearContractClasss,
    state => adapter.removeAll(state)
  ),
);

export function reducer(state: State | undefined, action: Action) {
  return classReducer(state, action);
}

export const selectContractClassState = createFeatureSelector<State>(
  contractClassesFeatureKey
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors(selectContractClassState);
